import type { Sticker } from '../types';

export const essentials2: Sticker[] = [
  {
    id: 30001,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/001-maths.png',
    name: 'Matematyka',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30002,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/002-file.png',
    name: 'Plik',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30003,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/003-music.png',
    name: 'Muzyka',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30004,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/004-worker.png',
    name: 'Pracownik',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30005,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/005-calendar.png',
    name: 'Kalendarz',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30006,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/006-cloud-server.png',
    name: 'Serwer w Chmurze',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30007,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/007-compass.png',
    name: 'Kompas',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30008,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/008-equalizer.png',
    name: 'Korektor',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30009,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/009-server.png',
    name: 'Serwer',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30010,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/010-diamond.png',
    name: 'Diament',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30011,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/011-study.png',
    name: 'Nauka',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30012,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/012-certificate.png',
    name: 'Certyfikat',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30013,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/013-clock.png',
    name: 'Zegar',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30014,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/014-file.png',
    name: 'Dokument',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30015,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/015-full-battery.png',
    name: 'Pełna Bateria',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30016,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/016-bell.png',
    name: 'Dzwonek',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30017,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/017-archive.png',
    name: 'Archiwum',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30018,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/018-low-battery.png',
    name: 'Słaba Bateria',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30019,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/019-binoculars.png',
    name: 'Lornetka',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 30020,
    url: 'https://stickers.nauczniaczek.pl/colections/14890406-essentials/png/020-reading.png',
    name: 'Czytanie',
    category: 'essentials-2',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];